import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=4d8f2072&scoped=true"
import script from "./Reader.vue?vue&type=script&lang=ts"
export * from "./Reader.vue?vue&type=script&lang=ts"
import style0 from "./Reader.vue?vue&type=style&index=0&id=4d8f2072&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f2072",
  null
  
)

export default component.exports